import { Formik, Form } from 'formik'
import { Fragment, useState } from 'react'
import Fields from '@components/fields'
import Column from '@components/column'
import Button from '@components/button'
import { StyleGrid, StyleGridItem, styleDocumentUploadWrapper } from '../style'
import { AuthSchema } from '@validations'
import { Document } from '@apis'
import { useSelector } from 'react-redux'
import { store, Actions } from '@store'
const Identifications = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const identifications = user?.documents?.filter(
    (document: any) => document?.type == 'Identification',
  )
  const citizenship = identifications?.findIndex(
    (document) => document?.infos?.name == 'Citizenship',
  )
  const passport = identifications?.findIndex(
    (document) => document?.infos?.name == 'Passport',
  )
  const nationalId = identifications?.findIndex(
    (document) => document?.infos?.name == 'National Id',
  )
  const [initialValues] = useState({
    type: 'Identification',
    documents:
      identifications?.length >= 3
        ? identifications
        : [
            !!identifications?.[citizenship]
              ? {
                  ...identifications[citizenship]?.infos,
                  oldPath: identifications[citizenship]?.infos?.image,
                  id: identifications[citizenship]?.id,
                }
              : {
                  image: '',
                  name: 'Citizenship',
                  number: '',
                },
            !!identifications?.[passport]
              ? {
                  ...identifications[passport]?.infos,
                  oldPath: identifications[passport]?.infos?.image,
                  id: identifications[passport]?.id,
                }
              : {
                  image: '',
                  name: 'Passport',
                  number: '',
                },
            !!identifications?.[nationalId]
              ? {
                  ...identifications[nationalId]?.infos,
                  oldPath: identifications[nationalId]?.infos?.image,
                  id: identifications[nationalId]?.id,
                }
              : {
                  image: '',
                  name: 'National Id',
                  number: '',
                },
          ],
  })

  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    const documents = values?.documents?.filter(
      (document) => !!document?.number,
    )

    setLoading(true)
    if (!!documents?.length) {
      const payload = {
        type: values?.type,
        documents: documents?.map((document: any) => {
          const item: any = {
            name: document?.name,
            number: document?.number,
          }
          if (document?.id) {
            item.id = document?.id
          }
          if (document?.image?.base64) {
            item.image = {
              base64: document?.image?.base64,
              extension: document?.image?.extension,
            }
            item.oldPath = document.oldPath
          } else if (typeof document?.image == 'string') {
            item.image = document?.image
          }

          return item
        }),
      }
      await Document.createOrUpdate({
        data: payload,
      })
        .then((resp) => {
          store.dispatch(
            Actions.update('user', {
              ...user,
              documents: resp,
            }),
          )
        })
        .catch(() => {})
    }
    setLoading(false)
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={AuthSchema.identificationsValidationSchema}
    >
      {({ handleSubmit, values, errors }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Column rowGap={20}>
              <StyleGrid>
                {values?.documents?.map((_, index: number) => {
                  return (
                    <Fragment key={index}>
                      <StyleGridItem>
                        <Fields.Upload
                          varient="drag"
                          name={`documents[${index}][image]`}
                          placeholder="Upload Document Here"
                          styleWrapper={styleDocumentUploadWrapper}
                          size={180}
                          icon={'circleGallery'}
                        />
                        <Column rowGap={20} styleColumn="margin-top:20px;">
                          <Fields.Input
                            name={`documents[${index}][name]`}
                            placeholder="Document Type"
                            label="Document Type"
                            disabled={true}
                          />
                          <Fields.Input
                            name={`documents[${index}][number]`}
                            placeholder="Document Number"
                            label="Document Number"
                          />
                        </Column>
                      </StyleGridItem>
                    </Fragment>
                  )
                })}
              </StyleGrid>
              <Column alignItems="flex-end">
                <Button
                  type="submit"
                  title="Submit"
                  height={40}
                  loading={loading}
                />
              </Column>
            </Column>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Identifications
